module.exports = __webpack_public_path__ + "static/img_2082-bc578589cce02d7d05ba4eb4a8a7c16b.webp";